import { render } from "./PageContainer.vue?vue&type=template&id=6043b8e6"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"

import "./PageContainer.vue?vue&type=style&index=0&id=6043b8e6&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__